import {Component, inject, Input, OnInit} from '@angular/core';
import {IonButton, IonContent, ModalController} from '@ionic/angular/standalone';
import {HeaderComponent} from '../../../common/header/header.component';
import {FooterComponent} from '../../../common/footer/footer.component';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-contact-success',
  templateUrl: './contact-success.component.html',
  styleUrls: ['./contact-success.component.scss'],
  imports: [
    IonButton,
    IonContent,
    HeaderComponent,
    FooterComponent,
    RouterLink,
  ]
})
export class ContactSuccessComponent  implements OnInit {
  @Input() message: string = '';
  modalController: ModalController = inject(ModalController);
  // options: AnimationOptions = {
  //   path: '/assets/animation/success.json',
  // };
  constructor() { }

  ngOnInit() {}

}
